/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback } from "react";
import ConfirmOrder from "components/ConfirmOrder";
import ConfirmRewardDialog from "./Components/ConfirmRewardDialog";
import DialogSignature from "./Components/DialogSignature";
import PagePullToRefresh from "./Components/PagePullToRefresh";
import { setSpecialOfferDetailAction } from "store/actions/ProgramDetailAction";
import { Grid } from "@material-ui/core";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { getTotalNotificationAction } from "store/actions/NotificationPageAction";
import { HEIGHT_FOOTER } from "config/constant";
import { getCRMLevelInfo } from "store/actions/InfoLoyaltyPageAction";
import { TAC } from "utils/config";

import {
	getCRMShopInfoDetail,
	getCRMRewardDetailAction,
	signatureRewardConfirmAction
} from "store/actions/HomePageAction";
import {
	setCartAction,
	setMenuChildrenHistoryAction,
	getListProductAction
} from "store/actions/OrderPageAction";
import {
	setAlertMessage,
	setValueSearchProductAction
} from "store/actions/GlobalAction";

let changeListProduct = [];
const height = `calc(100vh - ${HEIGHT_FOOTER}px)`;

const HomePage = props => {
	const history = useHistory();
	const {
		carts,
		listLoyalty,
		infoShop,
		dataInfoLoyalty,
		totalNotification,
		listProduct,
		crmRewardDetail,
		totalListProduct,
		dispatchSetCart,
		dispatchAlertMessage,
		dispatchGetTotalNotification,
		dispatchGetCRMShopInfoDetail,
		dispatchSetMenuChildrenHistory,
		dispatchGetCRMLevelInfo,
		dispatchSetValueSearchProduct,
		dispatchGetListProduct,
		dispatchGetCRMRewardDetail,
		dispatchSignatureRewardConfirm,
		dispatchSetSpecialOfferDetail
	} = props;

	const [isConfirmReward, setConfirmReward] = useState(false);
	const [isSignature, setSignature] = useState(false);

	const isSignRewardConfirm = infoShop?.isSignRewardConfirm;
	const business = infoShop?.business || TAC;

	useEffect(() => {
		if (!isSignRewardConfirm) {
			return;
		}
		dispatchGetCRMRewardDetail();
	}, [isSignRewardConfirm]);

	useEffect(() => {
		dispatchGetCRMShopInfoDetail();
		dispatchGetCRMLevelInfo();
		dispatchGetTotalNotification();
		dispatchSetMenuChildrenHistory(0);
	}, []);

	const getChangeListProduct = () => {
		return changeListProduct;
	};

	useEffect(() => {
		if (!carts) {
			return;
		}
		changeListProduct = carts;
	}, [carts]);

	const updateChangeListProduct = useCallback(item => {
		if (changeListProduct?.find(product => product.id === item.id)) {
			const dataFilter = changeListProduct.filter(
				el => el.id !== item.id
			);
			changeListProduct = dataFilter;
		} else {
			changeListProduct = [...changeListProduct, item];
		}
		dispatchSetCart(changeListProduct);
	}, []);

	const handleConfirmOrder = () => {
		history.push("/carts");
	};

	const handleInfoLoyaltyDefault = () => {
		history.push("/info_loyalty");
	};

	const handleSearchProduct = e => {
		dispatchSetValueSearchProduct(e);
		const data = {
			keyword: e,
			requirePrice: true,
			business: business
		};
		dispatchGetListProduct(data);
		history.push("/find_product");
	};

	const handleClickProgram = id => {
		const data = {
			business: business,
			id: id
		};
		dispatchSetSpecialOfferDetail(data);
		history.push(`/special_offer_detail?id=${id}`);
	};

	return (
		<Grid
			style={{
				overflowX: "hidden",
				overflowY: "hidden",
				height: height
			}}
		>
			<PagePullToRefresh
				totalNotification={totalNotification}
				infoShop={infoShop}
				dataInfoLoyalty={dataInfoLoyalty}
				listLoyalty={listLoyalty}
				products={listProduct}
				carts={carts}
				business={business}
				totalListProduct={totalListProduct}
				handleSearchProduct={handleSearchProduct}
				handleInfoLoyaltyDefault={handleInfoLoyaltyDefault}
				handleClickProgram={handleClickProgram}
				setConfirmReward={setConfirmReward}
				updateChangeListProduct={updateChangeListProduct}
				dispatchAlertMessage={dispatchAlertMessage}
				dispatchGetCRMShopInfoDetail={dispatchGetCRMShopInfoDetail}
				dispatchGetCRMRewardDetail={dispatchGetCRMRewardDetail}
				dispatchGetListProduct={dispatchGetListProduct}
			/>
			<ConfirmRewardDialog
				open={isConfirmReward}
				crmRewardDetail={crmRewardDetail}
				handleClose={() => {
					setConfirmReward(false);
				}}
				handleConfirm={() => {
					setConfirmReward(false);
					setSignature(true);
				}}
			/>
			<DialogSignature
				signatureRewardConfirm={dispatchSignatureRewardConfirm}
				open={isSignature}
				handleClose={() => {
					setSignature(false);
					dispatchGetCRMShopInfoDetail();
				}}
			/>
			{carts?.length > 0 && (
				<ConfirmOrder
					bottom={50}
					handleConfirmOrder={handleConfirmOrder}
					listProduct={carts}
					getChangeListProduct={getChangeListProduct}
				/>
			)}
		</Grid>
	);
};

const mapStateToProps = state => {
	return {
		carts: state.orderPageReducer.carts,
		listLoyalty: state.specialOfferPageReducer.listLoyalty,
		infoShop: state.homePageReducer.infoShop,
		dataInfoLoyalty: state.infoLoyaltyPageReducer.dataInfoLoyalty,
		totalNotification: state.notificationPageReducer.total,
		listProduct: state.orderPageReducer.listProduct,
		crmRewardDetail: state.homePageReducer.crmRewardDetail,
		totalListProduct: state.orderPageReducer.totalListProduct
	};
};

const mapDispatchToProps = dispatch => {
	return {
		dispatchSetCart: params => {
			dispatch(setCartAction(params));
		},
		dispatchAlertMessage: params => {
			dispatch(setAlertMessage(params));
		},
		dispatchGetTotalNotification: () => {
			dispatch(getTotalNotificationAction());
		},
		dispatchGetCRMShopInfoDetail: () => {
			dispatch(getCRMShopInfoDetail());
		},
		dispatchSetMenuChildrenHistory: params => {
			dispatch(setMenuChildrenHistoryAction(params));
		},
		dispatchGetCRMLevelInfo: () => {
			dispatch(getCRMLevelInfo());
		},
		dispatchSetValueSearchProduct: params => {
			dispatch(setValueSearchProductAction(params));
		},
		dispatchGetListProduct: params => {
			dispatch(getListProductAction(params));
		},
		dispatchGetCRMRewardDetail: () => {
			dispatch(getCRMRewardDetailAction());
		},
		dispatchSignatureRewardConfirm: params => {
			dispatch(signatureRewardConfirmAction(params));
		},
		dispatchSetSpecialOfferDetail: params => {
			dispatch(setSpecialOfferDetailAction(params));
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
